import { BasicMoreSettings } from './BasicMoreSettings'
import UnsecuredAccessToggle from 'apps/builder/components/shared/unsecuredAccessToggle';

export const AttachmentMoreSettings = entry => {
  return (
    <>
      <div className="settings--row">
        <UnsecuredAccessToggle guid={entry.guid} allow_unsecured_access={entry.allow_unsecured_access} mediaType="attachment" />
      </div>
      <BasicMoreSettings
        mobileVisible={false}
        pageBreakAfter={false}
        placeValueIn={false}
        {...entry}
      />
    </>
  )
}